import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Modal from 'react-modal';
import LocationListForm from '../supplies/location-list-form-new.js';
import { closeLocationListCreateModal } from '../../actions/location-list-actions.js';
import './modal-common.css';
import './modal-create-location-list.css';

export class ModalCreateLocationList extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      success: false,
    };
  }

  componentWillUnmount() {
    this.successTimeout && window.clearTimeout(this.successTimeout);
  }

  unsetSuccess = () => {
    this.setState(() => {
      return {
        success: false,
      };
    });
    this.onRequestClose();
  };

  onSuccess = () => {
    this.setState(() => {
      return {
        success: true,
      };
    });
    this.successTimeout = window.setTimeout(this.unsetSuccess, 5000);
  };

  onRequestClose = () => {
    this.props.actions.closeLocationListCreateModal();
  };

  handleCloseModal = () => {
    this.onRequestClose();
  };

  render() {
    return (
      <Modal
        appElement={document.getElementById('root')}
        isOpen={this.props.openCreateModal}
        onRequestClose={this.onRequestClose}
        onAfterOpen={this.onAfterOpen}
        shouldCloseOnOverlayClick={true}
        className={{
          base: 'modal',
          afterOpen: 'modal_after-open',
          beforeClose: 'modal_before-close',
        }}
        overlayClassName={{
          base: 'modal-overlay',
          afterOpen: 'modal-overlay_after-open',
          beforeClose: 'modal-overlay_before-close',
        }}
        contentLabel="Create New Location List Modal"
      >
        <div className="modal-create-location-list">
          <button className="close-icon" onClick={this.handleCloseModal}>
            &times;
          </button>
          <h3>Create New Supply List</h3>
          <div className="location-list-form-new-toggle">
            {!this.state.success && (
              <LocationListForm onSuccess={this.onSuccess} />
            )}
            {this.state.success && (
              <div className="success brand-bg-color-override">
                <p className="success-message">
                  Great! Your new supply list has been created. &nbsp;You can
                  now add to it.
                </p>
              </div>
            )}
          </div>
        </div>
      </Modal>
    );
  }
}

ModalCreateLocationList.propTypes = {
  actions: PropTypes.shape({
    closeLocationListCreateModal: PropTypes.func.isRequired,
  }).isRequired,
};

function mapStateToProps(state) {
  return {
    openCreateModal: state.locationLists.openCreateModal,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        closeLocationListCreateModal,
      },
      dispatch
    ),
  };
}

function areStatesEqual(prev, next) {
  return (
    prev.locationLists.openCreateModal === next.locationLists.openCreateModal
  );
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  areStatesEqual,
})(ModalCreateLocationList);
